import { Card, CardBody, Col, Label, Row } from "reactstrap";

//Common
import { fn_formatarDataHora } from "@/common/utils/date";

//Util
import { fn_formatarLog } from "@/frontend/utils/log";

function CardLogAutorizacao({ titulo, autorizacaoLog }) {
  return (
    <Card>
      <CardBody>
        <div className="custom-card-title mb-0  fw-bold text-danger">
          {titulo}
        </div>

        <Row className="mt-2">
          <Col>
            <div className="mb-2">
              <span className="fw-bold me-2">Usuário: </span>
              {autorizacaoLog.usuario.nome}
            </div>

            <div className="mb-2">
              <span className="fw-bold me-2">Data: </span>
              {fn_formatarDataHora(autorizacaoLog.data)}
            </div>

            <div>{fn_formatarLog(autorizacaoLog.log, "Motivo")}</div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

export default CardLogAutorizacao;
